import { Link } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';

import { useTranslation } from '../../context/TranslationContext.jsx';

import { DetailIcon, DetailRow } from './styles.js';

const EIFU_URL = 'https://ifu.sonda.reyedar.com/ifu.pdf';
const SUPPORT_EMAIL = 'support@reyedar.com';

const InstructionsForUse = ({ variant }) => {
  const { translate } = useTranslation();

  return (
    <>
      <DetailRow>
        <DetailIcon displayVariant={variant}>
          <DescriptionOutlinedIcon />
        </DetailIcon>
        <span>
          {translate('authPage.legal.electronicInstructionsBeforeLink')}{' '}
          <Link href={EIFU_URL} target="_blank" rel="noopener noreferrer">
            ifu.sonda.reyedar.com/ifu.pdf
          </Link>{' '}
          {translate('authPage.legal.electronicInstructionsAfterLink')}
        </span>
      </DetailRow>
      <DetailRow>
        <DetailIcon displayVariant={variant}>
          <MailOutlinedIcon />
        </DetailIcon>
        <span>
          {translate('authPage.legal.paperCopyBeforeLink')}{' '}
          <Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link>{' '}
          {translate('authPage.legal.paperCopyAfterLink')}
        </span>
      </DetailRow>
    </>
  );
};

export default InstructionsForUse;
